// Refund policy: one source of truth for the Pricing page, the receipt email and the server's consent record.
// Bump POLICY_VERSION whenever the wording changes; each subscriber's agreement is stored with the version they saw.
export const POLICY_VERSION = "2026-09-30";
export const POLICY_HEADINGS = ["NO REFUND POLICY", "NO PRO RATA REFUNDS AFTER SUBSCRIPTION CANCELLATION"] as const;
export const POLICY_POINTS = [
  "All subscription payments are final and non-refundable, including renewals.",
  "You can cancel any time. Cancelling stops future renewals; you keep access until the end of the period you have already paid for.",
  "No pro-rata or partial refunds are given for unused time after cancellation.",
  "Please use the 7-day free trial to decide whether the studio suits you before subscribing.",
] as const;
export const POLICY_AGREEMENT =
  "I have read and agree to the No Refund Policy, including no pro-rata refunds after subscription cancellation.";
